var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("span", { staticClass: "sip-callout-wrap" }, [
    !_vm.type
      ? _c("p", { staticClass: "alert alert-info" }, [
          _c("span", { staticClass: "sip-callout-copy" }, [
            _c("span", { staticClass: "sip-callout-label" }, [_vm._v("Note")]),
            _vm._v(
              "\n            " +
                _vm._s(_vm.trans(_vm.module + "." + _vm.tip)) +
                "\n        "
            ),
          ]),
        ])
      : _vm._e(),
    _vm._v(" "),
    _vm.type
      ? _c("i", { staticClass: "fas fa-info-circle float-right" })
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }